/**
 * Map internal module names to user-friendly display names
 */
export const MODULE_DISPLAY_NAMES = {
  subdomain_enum: 'Subdomain Lister',
  shodan_scan: 'Shodan Lookup',
  wappalyzer_scan: 'Technology Stack',
  nmap_scan: 'Nmap Scan',
  nuclei_scan: 'Nuclei Vuln Scanner',
  port_scan: 'Port Scan',
  ssl_scan: 'SSL/TLS Scan',
  tls_check: 'TLS/SSL Check',
  headers_check: 'Security Headers',
  tech_fingerprint: 'Tech Fingerprint',
  service_fingerprint: 'Service Fingerprint',
  whois_lookup: 'WHOIS Lookup',
  github_recon: 'GitHub Recon',
  google_dork: 'Google Dorking',
  certificate_transparency: 'Certificate Transparency',
  asn_lookup: 'ASN Lookup',
  ip_geolocation: 'IP Geolocation',
  reverse_dns: 'Reverse DNS',
  technology_detection: 'Technology Detection',
  vulnerability_scan: 'Vulnerability Scan',
  dns_zone: 'DNS Records',
  web_crawler: 'Web Crawler',
  dir_bruteforce: 'Directory Bruteforce',
  email_harvester: 'Email Harvester',
  metadata_extraction: 'Metadata Extraction',
  screenshot_capture: 'Screenshot Capture'
};

/**
 * Get friendly display name for a module
 * @param {string} moduleName - Internal module name
 * @returns {string} - User-friendly display name
 */
export const getModuleDisplayName = (moduleName) => {
  return MODULE_DISPLAY_NAMES[moduleName] || moduleName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
